import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import './style.css';

export interface TermsPageProps extends RouteComponentProps<{}> {}

export interface TermsPageState {
  /* empty*/
}

export class TermsPage extends React.Component<TermsPageProps, TermsPageState> {
  render() {
    return (
      <main className="terms-and-conditions plain-content-page" role="main">
        <h1 className="terms-and-conditions-header plain-content-page-header">
          Terms and Conditions
        </h1>
        <p>
          This site is owned and operated by Edge of Play Limited (“EOP”, “we”
          or “us”) Registered office: Alpha House, 4 Greek Street, Stockport,
          Cheshire, United Kingdom, SK3 8AB Registered in England No: 11036449
          (England and Wales). If you want to ask us anything about these terms
          & conditions or have any comments or complaints on or about our
          website, please call us on +44(0) 7411733406. These Terms & Conditions
          set out the basis on which you can visit and use our website. Please
          read them carefully as they contain important information. By
          accessing the website you are accepting them and agreeing to be bound
          by them. If you do not want to be bound by them, please leave the
          website now.
        </p>

        <h3>Ownership of Rights</h3>
        <p>
          All rights, including copyright, in this website are owned by or
          licensed to “EOP”. Any use of this website or its contents, including
          copying or storing it or them in whole or part, other than for your
          own personal, non-commercial use is prohibited without the permission
          of “EOP”. You may not modify, distribute or re-post anything on this
          website.
        </p>

        <h3>Changes to Terms or Services</h3>
        <p>
          We may modify the “EOP” terms and conditions at our discretion.
          Whenever we do we will let you know through our normal channels of
          communication (e-mail, social media) or we will post the changes on
          the site. It is important that you review the terms and conditions
          page whenever we make changes, as if you continue to use the website
          after we have notified you of the changes you are indicating to us
          that you agree to be bound by the modified document. If you don’t
          agree to the modified terms and conditions you can cancel your
          subscription (see cancellation and refunds below) and cease to use the
          website.
        </p>

        <h3>Accuracy of Content</h3>
        <p>
          “EOP” has taken every care in the preparation of the content of this
          website. However, to the extent allowed by applicable law, “EOP”, or
          any of our partners or associated clubs, disclaims all warranties,
          express or implied, as to the accuracy of the information contained in
          any of the materials on this website. “EOP” shall not be liable to any
          person for any loss or damage which may arise from the use of any of
          the information contained in any of the materials on this website.
        </p>

        <h3>Website Changes</h3>
        <p>
          The content on the “EOP” website is regularly updated and existing
          content may change at any time. Content or advice on our site may be
          out of date at any certain time and we are under no obligation to
          update the content.
          <br />
          <br />
          From time to time, we may restrict access to some parts of our site,
          or our entire site, to all users and, if the need arises, we may close
          the site indefinitely.
        </p>

        <h3>Information About You</h3>
        <p>
          We process information about you in accordance with our privacy
          policy. By using our site, you consent to such processing and you
          warrant that all data provided by you is accurate.
        </p>

        <h3>Subscription</h3>
        <p>
          In order to subscribe to Edge of Play we will require you to sign up
          with personal details and create your own password.
          <br />
          <br />
          It is your responsibility to keep these details confidential and
          secret. We are not liable for any loss or liability which may occur in
          connection with any unauthorised use of these details, including a
          third party accessing your account and the benefits that come with it.
        </p>

        <h3>Payment Processing through Edge of Play</h3>
        <p>
          We use Stripe to handle transactions through the website. When you
          subscribe to “EOP” services Stripe will use your credit or debit card
          to process the payment. We will provide Stripe with details of your
          card and the additional billing information collected through our
          payments area. This data will be stored by Stripe on our behalf in
          order for us to collect monthly subscriptions and to process any
          refunds or changes to your payment information. All of the billing and
          customer information we collect is encrypted for your safety. You can
          learn more about Stripe and its privacy policy at{' '}
          <a
            className="edge-of-play-link"
            href="https://stripe.com/privacy"
            target="_blank"
            rel="noopener nofollow"
          >
            https://stripe.com/privacy
          </a>
        </p>

        <h3>Cancellation and refunds</h3>
        <p>
          “EOP” subscription is billed in advance on a monthly or annual basis.
          If you choose to cancel your subscription at any time access to any
          videos that form part of your subscription will remain accessible for
          the remainder of your subscription term and is non-refundable.
          <br />
          <br />
          In the event of a refund we will look to refund any money received
          from you through our Stripe payment processing platform using the same
          method you used to pay your subscription.
        </p>

        <h3>Damage to your Computer</h3>
        <p>
          “EOP” makes every effort to ensure that this website is free from
          viruses or defects. However, we cannot guarantee that your use of this
          website or any websites accessible through it won’t cause damage to
          your computer. It is your responsibility to ensure that the right
          equipment is available to use the website and screen out anything that
          may damage it. “EOP” shall not be liable to any person for any loss or
          damage which may arise to computer equipment as a result of using this
          website.
        </p>

        <h3>Links to Other Websites</h3>
        <p>
          We have placed links on this website to other websites we think you
          may want to visit. We do not vet these websites and do not have any
          control over their contents. “EOP” cannot accept any liability in
          respect of the use of these websites.
        </p>

        <h3>Exclusions of Liability</h3>
        <p>
          Any disclaimers and exclusions of liability in these Terms &
          Conditions shall not apply to any damages arising from death or
          personal injury caused by the negligence of “EOP” or any of its
          employees or agents or fraud. These disclaimers and exclusions shall
          be governed by and construed in accordance with English Law. If any
          provisions of these disclaimers and exclusions shall be unlawful, void
          or for any reason unenforceable then that provision shall be deemed
          severable and shall not affect the validity and enforceability of the
          remaining provisions.
        </p>

        <h3>Other Legal Notices</h3>
        <p>
          There may be legal notices on other areas of this website which relate
          to your use of this website, all of which will, together with these
          terms & conditions govern your use of this website.
        </p>

        <h3>Changes to Legal Notices</h3>
        <p>
          We reserve the right to change these Terms & Conditions from time to
          time and you should look through them as often as possible. Should you
          access the website you will be deemed to have accepted any of the
          changes made to these terms and conditions from time to time.
        </p>

        <h3>Use of this Website from outside the UK</h3>
        <p>
          Unless otherwise specified, the materials on this website are directed
          solely at those who access this website from the United Kingdom. “EOP”
          make no representation that any products or services referred to in
          the materials on this website are appropriate for use, or available,
          in other locations. Those who choose to access this site from other
          locations are responsible for compliance with local laws if and to the
          extent local laws are applicable.
        </p>

        <h3>Law, Jurisdiction and Language</h3>
        <p>
          This website, any content contained herein and any contract brought
          into being as a result of usage of this website are governed by and
          construed in accordance with English Law. The parties to any such
          contract agree to submit to the exclusive jurisdiction of the courts
          of England and Wales. All contracts are concluded in English.
        </p>
        <br />
        <p>
          <b>
            IF YOU DO NOT WISH TO BE BOUND BY THESE TERMS & CONDITIONS PLEASE
            LEAVE THIS WEBSITE IMMEDIATELY
          </b>
        </p>
      </main>
    );
  }
}

export default TermsPage;



// WEBPACK FOOTER //
// ./src/app/containers/TermsPage/index.tsx